// src/components/common/userform/tablePresets.js
export const TABLE_PRESETS = {
  PlanLines: {
    label: "PS 수급계획 표",
    form: "PS",
    role: "lines",
    columns: [
      { key: "code", label: "코드", type: "text", width: "14%" },
      { key: "name", label: "품명", type: "text", width: "22%" },
      { key: "spec", label: "규격", type: "text", width: "18%" },
      { key: "unit", label: "단위", type: "text", width: "8%" },
      { key: "qty", label: "수량", type: "number", width: "10%" },
      { key: "due_date", label: "납기", type: "date", width: "14%" },
      { key: "remark", label: "비고", type: "text", width: "14%" },
    ],
  },
  OrderLines: {
    label: "PO 발주 표",
    form: "PO",
    role: "lines",
    columns: [
      { key: "code", label: "코드", type: "text" },
      { key: "name", label: "품명", type: "text" },
      { key: "spec", label: "규격", type: "text" },
      { key: "unit", label: "단위", type: "text" },
      { key: "qty", label: "수량", type: "number" },
      { key: "price", label: "단가", type: "number" },
      { key: "amount", label: "금액", type: "calc" },
      { key: "remark", label: "비고", type: "text" },
    ],
  },
  StockInLines: {
    label: "GR 입고 표(재고)",
    form: "GR",
    role: "lines",
    columns: [
      { key: "item_id", label: "자재ID", type: "number" }, // ✅ 필수
      { key: "code", label: "코드", type: "text" },
      { key: "name", label: "품명", type: "text" },
      { key: "spec", label: "규격", type: "text" },
      { key: "unit", label: "단위", type: "text" },
      { key: "qty", label: "수량(+)", type: "number" },
      { key: "price", label: "단가", type: "number" },
      { key: "amount", label: "금액", type: "calc" },
      { key: "lot", label: "LOT", type: "text" },
      { key: "remark", label: "비고", type: "text" },
    ],
  },
  StockOutLines: {
    label: "GI 출고 표(재고)",
    form: "GI",
    role: "lines",
    columns: [
      { key: "item_id", label: "자재ID", type: "number" }, // ✅ 필수
      { key: "code", label: "코드", type: "text" },
      { key: "name", label: "품명", type: "text" },
      { key: "spec", label: "규격", type: "text" },
      { key: "unit", label: "단위", type: "text" },
      { key: "qty", label: "수량(-)", type: "number" },
      { key: "remark", label: "비고", type: "text" },
    ],
  },
  Generic: {
    label: "일반 표",
    form: null,
    role: "generic",
    columns: [
      { key: "col1", label: "컬럼1", type: "text" },
      { key: "col2", label: "컬럼2", type: "text" },
    ],
  },
};
